<div>
  
</div>
<p-table #dataTable selectionMode="single" [value]="bookings"
  [loading]="bookingSearchService.loading" [showLoader]="true">
  <ng-template pTemplate="header">
    <tr>
      <th [style]="{'width':'80px'}" pSortableColumn="id">ID
        <p-sortIcon field="id"></p-sortIcon>
      </th>
      <th [style]="{'width':'100px'}" id="active-head" pSortableColumn="active">Active
        <p-sortIcon field="active"></p-sortIcon>
      </th>
      <th pSortableColumn="firstName">
        First name
        <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="studentLastName">
        Last name
        <p-sortIcon field="studentLastName"></p-sortIcon>
      </th>
      <th pSortableColumn="school.name">
        School
        <p-sortIcon field="school.name"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="courseName">
        Course
        <p-sortIcon field="courseName"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="startDate">Start
        <p-sortIcon field="startDate"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="endDate">
        End
        <p-sortIcon field="endDate"></p-sortIcon>
      </th>
      <th [style]="{'width':'130px'}" pSortableColumn="language.id">
        Language
        <p-sortIcon field="language.id"></p-sortIcon>
      </th>
      <th [style]="{'width':'130px'}" pSortableColumn="duration">
        Duration
        <p-sortIcon field="duration"></p-sortIcon>
      </th>
    </tr>
    <tr>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'id', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <div class="checkbox-container">
          <p-checkbox [binary]="true" (onChange)="dataTable.filter($event.checked, 'active', 'equals')"></p-checkbox>
          <p-button icon="pi pi-times" (onClick)="dataTable.filter(null, 'active', 'equals')"></p-button>
        </div>
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'firstName', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'lastName', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'course', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <p-calendar appendTo="body" (onSelect)="onDateSelect($event, 'startDate')"
          (onClearClick)="dataTable.filter('', 'startDate', 'equals')" [showButtonBar]="true" [readonlyInput]="true"
          dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
      </th>
      <th>
        <p-calendar appendTo="body" (onSelect)="onDateSelect($event, 'endDate')"
          (onClearClick)="dataTable.filter('', 'endDate', 'equals')" [showButtonBar]="true" [readonlyInput]="true"
          dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
      </th>
      <th>
        <!-- <p-dropdown [style]="{'min-width':'100%'}" placeholder="select" [options]="languages"
          (onChange)="dataTable.filter($event.value?.id, 'language.id', 'equals')" optionLabel="name" showClear="true"> -->
          <!-- <ng-template let-language pTemplateName="item">
            <span>{{language.name | titlecase}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'duration', 'contains')" -->
          <!-- [style]="{'width':'100%'}"> -->
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-booking>
    <tr [pSelectableRow]="booking">
      <td id="id">
        <a (click)="openBooking(booking)">
          {{booking.id}}
        </a>
      </td>
      <td id="active">
        <span *ngIf="booking.active">
          X
        </span>
      </td>
      <td id="first-name">
        <a (click)="openBooking(booking)">
          {{booking.firstName | titlecase}}
        </a>
      </td>
      <td id="last-name">
        <a (click)="openBooking(booking)">
          {{booking.lastName | titlecase}}
        </a>
      </td>
      <td>
        {{booking.school.name}}
      </td>
      <td>
        {{booking.course}}
      </td>
      <td id="start">
        {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
      </td>
      <td id="end">
        {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
      </td>
      <td>
        {{booking.language.name | titlecase}}
      </td>
      <td>
        {{booking.duration}}
      </td>
    </tr>
  </ng-template>
</p-table>